import React from 'react';
import { Tag } from 'antd';

const status = {
  "DRAFT": "",
  "DIAJUKAN": "grey",
  "DISETUJUI": "blue",
  "DITOLAK": "red",
  "AUTO APPROVAL": "blue",
}

// Label yang tampil ke user (konsisten Bahasa Indonesia)
const statusLabel = {
  "AUTO APPROVAL": "DISETUJUI OTOMATIS",
}

const LabelStatusPerizinan = ({ ...props }) => {

  if (props.status) {
    return (
      <Tag color={status[props.status]}> {statusLabel[props.status] || props.status}</Tag>
    );
  }
  return (
    "-"
  );
};
export default LabelStatusPerizinan;
